import Flex from "@/components-library/layout/flex";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useCallback, useState } from "react";

const ELEMENT_TO_REMOVE = 1;
const ARRAY_NOMATCH = -1;
const FIRST_ELEMENT = 0;

function ExpandableGroup({
  children,
  initialIndexOpen,
  direction,
  singleOpen,
  className,
  onToggleCallback,
  style,
}) {
  const [currentOpen, setCurrentOpen] = useState(
    initialIndexOpen ? [initialIndexOpen] : []
  );

  useEffect(() => {
    if (Number.isInteger(initialIndexOpen)) setCurrentOpen([initialIndexOpen]);
  }, [initialIndexOpen]);

  useEffect(() => {
    if (singleOpen) {
      setCurrentOpen(
        Number.isInteger(initialIndexOpen) ? [initialIndexOpen] : []
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleOpen]);

  const handleToggle = useCallback(
    (index) => {
      if (singleOpen) {
        setCurrentOpen((prev) => {
          return prev.indexOf(index) !== ARRAY_NOMATCH ? [] : [index];
        });

        if (onToggleCallback)
          onToggleCallback(
            currentOpen.length && currentOpen[FIRST_ELEMENT] === index
              ? null
              : index
          );
      } else {
        let currentOpenClone = [...currentOpen];
        let newCurrentOpen = [];

        if (currentOpen.indexOf(index) !== ARRAY_NOMATCH) {
          currentOpenClone.splice(
            currentOpenClone.indexOf(index),
            ELEMENT_TO_REMOVE
          );

          newCurrentOpen = [...currentOpenClone];
        } else {
          newCurrentOpen = [...currentOpenClone, index];
        }

        setCurrentOpen(newCurrentOpen);
        if (onToggleCallback) onToggleCallback(newCurrentOpen);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentOpen]
  );

  const elements = Array.isArray(children) ? children : [children];

  return (
    <Flex
      direction={direction === "down" ? "column" : "row"}
      justify="flex-start"
      align="stretch"
      className={className}
      style={style}
    >
      {elements.map((el, index) => (
        <el.type
          key={index}
          {...el.props}
          isOpen={currentOpen.indexOf(index) !== ARRAY_NOMATCH}
          onToggle={() => handleToggle(index)}
        />
      ))}
    </Flex>
  );
}

ExpandableGroup.propTypes = {
  children: PropTypes.node.isRequired,
  initialIndexOpen: PropTypes.number,
  direction: PropTypes.oneOf(["down", "right"]).isRequired,
  singleOpen: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  style: PropTypes.object.isRequired,
};

ExpandableGroup.defaultProps = {
  direction: "down",
  singleOpen: false,
  className: "",
  style: {},
};

export default ExpandableGroup;
